// Timezone configuration for the application
// This file contains all available timezone options with their display names and values

export const timezoneOptions = [
    // North America
    {
        label: "Eastern Time (US & Canada) - EST/EDT (UTC-5)",
        value: "America/New_York",
        region: "North America",
        abbreviation: "EST/EDT"
    },
    {
        label: "Central Time (US & Canada) - CST/CDT (UTC-6)",
        value: "America/Chicago",
        region: "North America",
        abbreviation: "CST/CDT"
    },
    {
        label: "Mountain Time (US & Canada) - MST/MDT (UTC-7)",
        value: "America/Denver",
        region: "North America",
        abbreviation: "MST/MDT"
    },
    {
        label: "Pacific Time (US & Canada) - PST/PDT (UTC-8)",
        value: "America/Los_Angeles",
        region: "North America",
        abbreviation: "PST/PDT"
    },
    {
        label: "Alaska Time - AKST/AKDT (UTC-9)",
        value: "America/Anchorage",
        region: "North America",
        abbreviation: "AKST/AKDT"
    },
    {
        label: "Hawaii Time - HST/HDT (UTC-10)",
        value: "Pacific/Honolulu",
        region: "North America",
        abbreviation: "HST/HDT"
    },
    { label: "Arizona Time - MST (UTC-7)", value: "America/Phoenix", region: "North America", abbreviation: "MST" },
    {
        label: "Atlantic Time (Canada) - AST/ADT (UTC-4)",
        value: "America/Halifax",
        region: "North America",
        abbreviation: "AST/ADT"
    },
    {
        label: "Newfoundland Time - NST/NDT (UTC-3:30)",
        value: "America/St_Johns",
        region: "North America",
        abbreviation: "NST/NDT"
    },

    // Europe
    { label: "London (GMT) - GMT/BST (UTC+0)", value: "Europe/London", region: "Europe", abbreviation: "GMT/BST" },
    { label: "Paris (CET) - CET/CEST (UTC+1)", value: "Europe/Paris", region: "Europe", abbreviation: "CET/CEST" },
    { label: "Berlin (CET) - CET/CEST (UTC+1)", value: "Europe/Berlin", region: "Europe", abbreviation: "CET/CEST" },
    { label: "Rome (CET) - CET/CEST (UTC+1)", value: "Europe/Rome", region: "Europe", abbreviation: "CET/CEST" },
    { label: "Madrid (CET) - CET/CEST (UTC+1)", value: "Europe/Madrid", region: "Europe", abbreviation: "CET/CEST" },
    {
        label: "Amsterdam (CET) - CET/CEST (UTC+1)",
        value: "Europe/Amsterdam",
        region: "Europe",
        abbreviation: "CET/CEST"
    },
    {
        label: "Brussels (CET) - CET/CEST (UTC+1)",
        value: "Europe/Brussels",
        region: "Europe",
        abbreviation: "CET/CEST"
    },
    { label: "Vienna (CET) - CET/CEST (UTC+1)", value: "Europe/Vienna", region: "Europe", abbreviation: "CET/CEST" },
    { label: "Zurich (CET) - CET/CEST (UTC+1)", value: "Europe/Zurich", region: "Europe", abbreviation: "CET/CEST" },
    {
        label: "Stockholm (CET) - CET/CEST (UTC+1)",
        value: "Europe/Stockholm",
        region: "Europe",
        abbreviation: "CET/CEST"
    },
    { label: "Oslo (CET) - CET/CEST (UTC+1)", value: "Europe/Oslo", region: "Europe", abbreviation: "CET/CEST" },
    {
        label: "Copenhagen (CET) - CET/CEST (UTC+1)",
        value: "Europe/Copenhagen",
        region: "Europe",
        abbreviation: "CET/CEST"
    },
    {
        label: "Helsinki (EET) - EET/EEST (UTC+2)",
        value: "Europe/Helsinki",
        region: "Europe",
        abbreviation: "EET/EEST"
    },
    { label: "Warsaw (CET) - CET/CEST (UTC+1)", value: "Europe/Warsaw", region: "Europe", abbreviation: "CET/CEST" },
    { label: "Prague (CET) - CET/CEST (UTC+1)", value: "Europe/Prague", region: "Europe", abbreviation: "CET/CEST" },
    {
        label: "Budapest (CET) - CET/CEST (UTC+1)",
        value: "Europe/Budapest",
        region: "Europe",
        abbreviation: "CET/CEST"
    },
    { label: "Moscow (MSK) - MSK (UTC+3)", value: "Europe/Moscow", region: "Europe", abbreviation: "MSK" },
    { label: "Istanbul (TRT) - TRT (UTC+3)", value: "Europe/Istanbul", region: "Europe", abbreviation: "TRT" },

    // Asia
    { label: "Tokyo (JST) - JST (UTC+9)", value: "Asia/Tokyo", region: "Asia", abbreviation: "JST" },
    { label: "Seoul (KST) - KST (UTC+9)", value: "Asia/Seoul", region: "Asia", abbreviation: "KST" },
    { label: "Shanghai (CST) - CST (UTC+8)", value: "Asia/Shanghai", region: "Asia", abbreviation: "CST" },
    { label: "Beijing (CST) - CST (UTC+8)", value: "Asia/Shanghai", region: "Asia", abbreviation: "CST" },
    { label: "Hong Kong (HKT) - HKT (UTC+8)", value: "Asia/Hong_Kong", region: "Asia", abbreviation: "HKT" },
    { label: "Singapore (SGT) - SGT (UTC+8)", value: "Asia/Singapore", region: "Asia", abbreviation: "SGT" },
    { label: "Bangkok (ICT) - ICT (UTC+7)", value: "Asia/Bangkok", region: "Asia", abbreviation: "ICT" },
    { label: "Jakarta (WIB) - WIB (UTC+7)", value: "Asia/Jakarta", region: "Asia", abbreviation: "WIB" },
    { label: "Manila (PHT) - PHT (UTC+8)", value: "Asia/Manila", region: "Asia", abbreviation: "PHT" },
    { label: "Kuala Lumpur (MYT) - MYT (UTC+8)", value: "Asia/Kuala_Lumpur", region: "Asia", abbreviation: "MYT" },
    { label: "New Delhi (IST) - IST (UTC+5:30)", value: "Asia/Kolkata", region: "Asia", abbreviation: "IST" },
    { label: "Mumbai (IST) - IST (UTC+5:30)", value: "Asia/Kolkata", region: "Asia", abbreviation: "IST" },
    { label: "Dubai (GST) - GST (UTC+4)", value: "Asia/Dubai", region: "Asia", abbreviation: "GST" },
    { label: "Abu Dhabi (GST) - GST (UTC+4)", value: "Asia/Dubai", region: "Asia", abbreviation: "GST" },
    { label: "Tehran (IRST) - IRST (UTC+3:30)", value: "Asia/Tehran", region: "Asia", abbreviation: "IRST" },
    { label: "Jerusalem (IST) - IST (UTC+2)", value: "Asia/Jerusalem", region: "Asia", abbreviation: "IST" },

    // Australia & Oceania
    {
        label: "Sydney (AEDT) - AEDT/AEST (UTC+11)",
        value: "Australia/Sydney",
        region: "Australia & Oceania",
        abbreviation: "AEDT/AEST"
    },
    {
        label: "Melbourne (AEDT) - AEDT/AEST (UTC+11)",
        value: "Australia/Melbourne",
        region: "Australia & Oceania",
        abbreviation: "AEDT/AEST"
    },
    {
        label: "Brisbane (AEST) - AEST (UTC+10)",
        value: "Australia/Brisbane",
        region: "Australia & Oceania",
        abbreviation: "AEST"
    },
    {
        label: "Perth (AWST) - AWST (UTC+8)",
        value: "Australia/Perth",
        region: "Australia & Oceania",
        abbreviation: "AWST"
    },
    {
        label: "Adelaide (ACST) - ACST/ACDT (UTC+9:30)",
        value: "Australia/Adelaide",
        region: "Australia & Oceania",
        abbreviation: "ACST/ACDT"
    },
    {
        label: "Darwin (ACST) - ACST (UTC+9:30)",
        value: "Australia/Darwin",
        region: "Australia & Oceania",
        abbreviation: "ACST"
    },
    {
        label: "Auckland (NZDT) - NZDT/NZST (UTC+13)",
        value: "Pacific/Auckland",
        region: "Australia & Oceania",
        abbreviation: "NZDT/NZST"
    },
    {
        label: "Wellington (NZDT) - NZDT/NZST (UTC+13)",
        value: "Pacific/Auckland",
        region: "Australia & Oceania",
        abbreviation: "NZDT/NZST"
    },
    { label: "Fiji (FJT) - FJT (UTC+12)", value: "Pacific/Fiji", region: "Australia & Oceania", abbreviation: "FJT" },

    // South America
    {
        label: "São Paulo (BRT) - BRT/BRST (UTC-3)",
        value: "America/Sao_Paulo",
        region: "South America",
        abbreviation: "BRT/BRST"
    },
    {
        label: "Buenos Aires (ART) - ART (UTC-3)",
        value: "America/Argentina/Buenos_Aires",
        region: "South America",
        abbreviation: "ART"
    },
    {
        label: "Santiago (CLT) - CLT/CLST (UTC-3)",
        value: "America/Santiago",
        region: "South America",
        abbreviation: "CLT/CLST"
    },
    { label: "Lima (PET) - PET (UTC-5)", value: "America/Lima", region: "South America", abbreviation: "PET" },
    { label: "Bogotá (COT) - COT (UTC-5)", value: "America/Bogota", region: "South America", abbreviation: "COT" },
    { label: "Caracas (VET) - VET (UTC-4)", value: "America/Caracas", region: "South America", abbreviation: "VET" },
    { label: "Quito (ECT) - ECT (UTC-5)", value: "America/Guayaquil", region: "South America", abbreviation: "ECT" },

    // Africa
    { label: "Cairo (EET) - EET/EEST (UTC+2)", value: "Africa/Cairo", region: "Africa", abbreviation: "EET/EEST" },
    {
        label: "Johannesburg (SAST) - SAST (UTC+2)",
        value: "Africa/Johannesburg",
        region: "Africa",
        abbreviation: "SAST"
    },
    { label: "Lagos (WAT) - WAT (UTC+1)", value: "Africa/Lagos", region: "Africa", abbreviation: "WAT" },
    { label: "Nairobi (EAT) - EAT (UTC+3)", value: "Africa/Nairobi", region: "Africa", abbreviation: "EAT" },
    {
        label: "Casablanca (WET) - WET/WEST (UTC+0)",
        value: "Africa/Casablanca",
        region: "Africa",
        abbreviation: "WET/WEST"
    },
    { label: "Algiers (CET) - CET (UTC+1)", value: "Africa/Algiers", region: "Africa", abbreviation: "CET" },
    { label: "Tunis (CET) - CET (UTC+1)", value: "Africa/Tunis", region: "Africa", abbreviation: "CET" },
    { label: "Khartoum (CAT) - CAT (UTC+2)", value: "Africa/Khartoum", region: "Africa", abbreviation: "CAT" },
    { label: "Addis Ababa (EAT) - EAT (UTC+3)", value: "Africa/Addis_Ababa", region: "Africa", abbreviation: "EAT" },

    // UTC and GMT
    { label: "UTC (Coordinated Universal Time) - UTC (UTC+0)", value: "UTC", region: "UTC", abbreviation: "UTC" },
    { label: "GMT (Greenwich Mean Time) - GMT (UTC+0)", value: "GMT", region: "UTC", abbreviation: "GMT" }
];

// Helper function to get timezone options grouped by region
export const getTimezoneOptionsByRegion = () => {
    const grouped = {};
    timezoneOptions.forEach(option => {
        if (!grouped[option.region]) {
            grouped[option.region] = [];
        }
        grouped[option.region].push(option);
    });
    return grouped;
};

// Helper function to find a timezone option by value
export const findTimezoneByValue = value => {
    return timezoneOptions.find(option => option.value === value);
};

// Helper function to get timezone label by value
export const getTimezoneLabel = value => {
    const option = findTimezoneByValue(value);
    return option ? option.label : value;
};

// Helper function to get timezone region by value
export const getTimezoneRegion = value => {
    const option = findTimezoneByValue(value);
    return option ? option.region : "Unknown";
};

// Helper function to get timezone abbreviation by value
export const getTimezoneAbbreviation = value => {
    const option = findTimezoneByValue(value);
    return option ? option.abbreviation : value;
};

// Helper function to get grouped timezone options for Select component
export const getGroupedTimezoneOptions = () => {
    const grouped = {};

    timezoneOptions.forEach(option => {
        if (!grouped[option.region]) {
            grouped[option.region] = [];
        }
        grouped[option.region].push(option);
    });

    // Convert to PrimeVue grouped format
    return Object.keys(grouped).map(region => ({
        label: region,
        items: grouped[region]
    }));
};
